import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxWebSocketServiceState} from '../../../@interfaces';
import {
    WEBSOCKET_ADD_LISTENER,
    WEBSOCKET_REMOVE_LISTENER,
    WEBSOCKET_SET_CONNECTION_STATE,
    WEBSOCKET_SET_ERROR_MESSAGE
} from './constants';

const changeChannelListenerNumber = (
    state: IReduxWebSocketServiceState,
    channelName: string,
    amount: number
): IReduxWebSocketServiceState['channels'][string] => {
    const channel = state.channels[channelName];

    return {
        ...(channel ?? 0),
        name: channelName,
        listeners: Math.max(0, (channel?.listeners ?? 0) + amount),
    };
};

const reducer: Reducer = (state: IReduxWebSocketServiceState = initialState, action: IReduxAction): IReduxWebSocketServiceState => {
    switch (action.type) {
        case WEBSOCKET_SET_CONNECTION_STATE:
            const errorMessage = action.payload.errorMessage === null ?
                (
                    action.payload.connectionState === 'connected' ?
                        undefined :
                        state.errorMessage
                ) :
                action.payload.errorMessage;

            return {...state, ...action.payload, errorMessage};

        case WEBSOCKET_SET_ERROR_MESSAGE:
            return {...state, ...action.payload};

        case WEBSOCKET_ADD_LISTENER:
            return {
                ...state, channels: {
                    ...state.channels,
                    [action.payload.channel]: changeChannelListenerNumber(state, action.payload.channel, +1)
                }
            };

        case WEBSOCKET_REMOVE_LISTENER:
            return {
                ...state, channels: {
                    ...state.channels,
                    [action.payload.channel]: changeChannelListenerNumber(state, action.payload.channel, -1)
                }
            };

        default:
            break;
    }

    return state;
};

export default reducer;
